import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import IconContainer from "../iconContainer/iconContainer";
import { ReactComponent as UserSVG } from "../../../assets/images/user.svg";
import { ReactComponent as GearSvg } from "../../../assets/images/gear.svg";
import { ReactComponent as LogoutSvg } from "../../../assets/images/logout.svg";

import "./UserProfile.css";
import useTranslate from "../../../translate/useTranslate";

const UserProfile = function ({ user, signOut }) {
  const { t } = useTranslate();
  const profileLinkRef = useRef(null);

  const [menuIsShown, setMenuIsShown] = useState(false);

  useEffect(() => {
    if (menuIsShown) {
      if (profileLinkRef.current) {
        profileLinkRef.current.focus();
      }
    }
  }, [menuIsShown]);

  const toggle = () => {
    setMenuIsShown(!menuIsShown);
  };

  const signout = () => {
    signOut();
  };

  const location = useLocation();

  return (
    <>
      {menuIsShown && <div className="user-profile-bg" onClick={toggle} />}
      <div
        className={`${
          location.pathname.startsWith("/settings") ? "nav-on" : ""
        } user-profile`}
        onClick={toggle}
      >
        <div className="user-name">
          {`${user ? `${user.firstName} ${user.lastName}` : ""}`}{" "}
          <span className={`bg-arrow ${menuIsShown ? "up" : "down"}`}></span>
        </div>
        <ul className={`user-drop-down ${menuIsShown ? "" : "hide"}`}>
          <li>
            <Link to="/settings/site-wastes" className="user_flex">
              <div className="user_drop_icon">
                <IconContainer width={24}>
                  <GearSvg />
                </IconContainer>
              </div>
              <div className="user_drop_text">{t("Settings")}</div>
            </Link>
          </li>
          <li>
            <Link to="/" onClick={(e) => signout()} className="user_flex">
              <div className="user_drop_icon">
                <IconContainer width={24}>
                  <LogoutSvg />
                </IconContainer>
              </div>
              <div className="user_drop_text">{t("Logout")}</div>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default UserProfile;
